import Request from "../Request.js";

const users = {
  getCurrentUser() {
    return Request.get("/authentication/api/v1/user/")
  },
};

export default users;
